import { casesActions } from "configs";
import { useCurrentCase, useDispatch, useParams } from "duck";
import { useUpdatePostAnestheticVitalMutation } from "requests";

export const useUpdatePostAnestheticVital = () => {
  const dispatch = useDispatch();
  const { id: caseId } = useParams();
  const [update] = useUpdatePostAnestheticVitalMutation({
    ignoreResults: true
  });
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);

  return (value: string | number | null, id: number | string, name: string) => {
    const input = {
      ...(typeof id === "number" ? { _id: id } : { fakeId: id }),
      [name]: value
    };
    dispatch(
      casesActions.updatePostAnestheticVital({ _id: caseId, data: input })
    );

    if (shouldSync && typeof id === "number") {
      return update({ variables: { input: { _id: id, [name]: value } } });
    }
  };
};
